var _g, _g2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#818487",
    d: "M-39.55,24.647h-4.275c-0.485,0-0.879-0.393-0.879-0.879c0-0.485,0.393-0.879,0.879-0.879 h4.275c0.485,0,0.879,0.393,0.879,0.879C-38.671,24.253-39.064,24.647-39.55,24.647z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#818487",
    d: "M-41.551,27.522h-2.274c-0.485,0-0.879-0.393-0.879-0.879 c0-0.485,0.393-0.879,0.879-0.879h2.274c0.485,0,0.879,0.393,0.879,0.879C-40.672,27.129-41.065,27.522-41.551,27.522z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    display: "none",
    d: "M3.228,22c-0.33,0-0.641-0.129-0.875-0.363c-0.283-0.282-0.412-0.687-0.345-1.083l0.909-5.322 c0.044-0.255,0.163-0.484,0.345-0.666l11.898-11.9C15.584,2.242,16.186,2,16.813,2s1.231,0.243,1.655,0.665l2.856,2.858 c0.442,0.441,0.685,1.028,0.685,1.654s-0.243,1.213-0.685,1.654L9.425,20.729c-0.177,0.18-0.407,0.3-0.663,0.345l-5.326,0.908 C3.369,21.995,3.298,22,3.228,22z M5.314,16.007l-0.568,3.234l3.23-0.573l8.903-8.898l-2.662-2.662L5.314,16.007z M15.969,5.358 l2.662,2.662l0.845-0.845l-2.662-2.662L15.969,5.358z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.627,6.277l-3.9-3.9c-0.479-0.485-1.325-0.483-1.804-0.003L3.473,14.82c-0.312,0.312-0.593,0.854-0.669,1.291 l-0.785,4.574c-0.059,0.343,0.027,0.682,0.236,0.931c0.205,0.243,0.512,0.383,0.844,0.383c0.042,0,0.171-0.012,0.213-0.019 l4.575-0.785c0.435-0.074,0.977-0.355,1.291-0.668L21.625,8.08C21.866,7.841,21.999,7.521,22,7.181 C22,6.839,21.868,6.518,21.627,6.277z M8.118,19.466c-0.095,0.095-0.353,0.229-0.484,0.251l-4.046,0.694l0.694-4.045 c0.023-0.132,0.156-0.39,0.251-0.484l9.391-9.389l3.584,3.583L8.118,19.466z M18.568,9.016l-3.583-3.583l1.839-1.838l3.583,3.583 L18.568,9.016z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.df4693f32bf4e947399815158c4edd5b.svg";
export { ForwardRef as ReactComponent };